import React from 'react';
import NewHiresComponent from './NewHires/NewHires';

function NewHires() {
  return <NewHiresComponent />;
}

export default NewHires;